import React, { HTMLAttributeAnchorTarget, ReactElement } from 'react';
import { Button, ButtonProps, Link as ChakraLink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

type To = {
  pathname: string;
  state: {
    [key: string]: unknown;
  };
};

interface ILinkButtonProps extends ButtonProps {
  children?: ReactElement | string;
  icon?: ReactElement;
  target?: HTMLAttributeAnchorTarget;
  to: string | To;
}

export const LinkButton: React.FC<ILinkButtonProps> = ({
  children,
  icon,
  target,
  to,
  ...rest
}) => (
  <ChakraLink
    as={Link}
    to={to}
    _hover={{
      textDecoration: 'none',
    }}
    target={target}
  >
    <Button
      size="sm"
      fontSize="sm"
      colorScheme="blue"
      leftIcon={icon}
      {...rest}
    >
      {children}
    </Button>
  </ChakraLink>
);
